module.exports = __webpack_public_path__ + "img/c482be5.jpg";